import { ACCESS_TOKEN, TYPE_TOKEN } from './constants';
import {API_BASE_URL, apiUrls} from "../route/Routes";

function authHeaders() {
  return {
    authorization: TYPE_TOKEN + ' ' + localStorage.getItem(ACCESS_TOKEN)
  };
}

export function deleteDocument(id, options) {
  return fetch(API_BASE_URL + apiUrls.document + "/" + id, {
    headers: authHeaders(),
    method: 'DELETE',
    ...options
  }).then(response =>
    response.json().then(json => {
      if (!response.ok) {
        return Promise.reject(json);
      }

      return json;
    })
  ).catch( () => {});
}

/**
 * Fetch a document with the bearer token and return it as a Blob.
 * The document endpoint requires authentication, so it cannot be opened
 * through a plain <a href> or <img src>; the caller should turn the Blob
 * into an object URL (see fetchDocumentUrl).
 */
export function fetchDocumentBlob(id) {
  return fetch(API_BASE_URL + apiUrls.document + "/" + id, {
    headers: authHeaders(),
    method: 'GET'
  }).then(response => {
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem(ACCESS_TOKEN);
      }
      return Promise.reject(response);
    }

    return response.blob();
  });
}

/**
 * Fetch a document with the bearer token and return an object URL for it.
 * Callers must call URL.revokeObjectURL on the result once it is no longer needed.
 */
export function fetchDocumentUrl(id) {
  return fetchDocumentBlob(id).then(blob => URL.createObjectURL(blob));
}

/**
 * Fetch a document with the bearer token and trigger a browser "Save as" download.
 */
export function downloadDocument(id, fileName) {
  return fetchDocumentUrl(id).then(url => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || `document-${id}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Defer revoke so the browser has started the download before the URL is released.
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  });
}
